'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = UIMain;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var USES = (0, _reactUtils.keyMirror)({
  standard: null,
  dark: null
});

/**
 * Main body of the app. There should only be one per application.
 *
 * @category Layout
 */

function UIMain(_ref) {
  var className = _ref.className,
      children = _ref.children,
      flush = _ref.flush,
      use = _ref.use,
      other = _objectWithoutProperties(_ref, ['className', 'children', 'flush', 'use']);

  var classes = (0, _reactUtils.classNames)('private-main', className, {
    'private-main--flush': flush,
    'private-main--dark': use === USES.dark
  });

  return _react2.default.createElement(
    'main',
    _extends({}, other, { className: classes, role: 'main' }),
    children
  );
}

UIMain.propTypes = {
  children: _react.PropTypes.node.isRequired,
  className: _react.PropTypes.string,
  flush: _react.PropTypes.bool,
  use: _react.PropTypes.oneOf(Object.keys(USES))
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1115/js/layout/UIMain.js
// module id = 369
// module chunks = 0